import {
  FilterType,
  buildMyTrainingsDatatableFilter,
  useMyTrainingsDatatable,
} from 'generated/resources/datatable.graphql'
import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

const currentYear = moment().year()

const years = []
for (let i = currentYear + 1; i >= currentYear - 25; i--) {
  years.push(i)
}
const options = years.map((year) => {
  return {
    label: String(year),
    value: year,
  }
})
export const yearFilter = (source: ReturnType<typeof useMyTrainingsDatatable>) => {
  return buildMyTrainingsDatatableFilter(source, {
    type: FilterType.Integer,
    default: true,
    categories: [
      {
        kind: 'FreeField',
        operation: 'eq',
        description: i18n.t('trainings.trainings_table.filters.year_filter.description'),
        errorMessage: i18n.t('trainings.trainings_table.filters.year_filter.error_message'),
        validation: (value: string) => /^\d{4}$/.test(value),
        options: options,
      },
    ],
    identifier: 'yearFilter',
    path: 'year',
    title: i18n.t('trainings.create_training_modal.year'),
  })
}
